export const Logo = () => (
    <div className="flex flex-col items-start gap-1.5" data-testid="ted-ops-logo">
        <img
            src="/logo-wordmark.webp"
            alt="TED Ops AI"
            className="h-8 w-auto select-none sm:h-10 [filter:drop-shadow(0_0_18px_rgba(0,102,255,0.35))]"
            draggable="false"
        />
        <span
            className="hidden whitespace-nowrap font-mono-brand text-[11px] uppercase leading-none tracking-[0.12em] text-[#B8C8DF] sm:block"
            data-testid="logo-tagline"
        >
            Technology. Efficiency. Decisions.
        </span>
    </div>
);
